import useTokenStore from "@/store/token";
import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/logout")({
  loader: async () => {
    await useTokenStore.getState().logout();
    throw redirect({to: "/login", replace: true});
  },
});
